import React from 'react'
import { cn } from 'lib/utils'

export interface Props {
	/** Display names of everyone currently typing, excluding the reader. */
	typists: string[]
	/** Show the "X is typing" caption. Off in 1:1, where it adds nothing. */
	showNames?: boolean
	className?: string
}

const caption = (typists: string[]) => {
	if (typists.length === 1) return `${typists[0]} is typing`
	if (typists.length === 2) return `${typists[0]} and ${typists[1]} are typing`
	return `${typists[0]} and ${typists.length - 1} others are typing`
}

/** The three-dot incoming bubble. Renders nothing when nobody is typing. */
const TypingIndicator = ({ typists, showNames = false, className = '' }: Props) => {
	if (!typists || typists.length === 0) return null

	return (
		<div
			data-testid="typing-indicator"
			className={cn('flex flex-col items-start gap-0.5', className)}
			aria-live="polite"
		>
			{showNames && <span className="text-[11px] text-gray-500">{caption(typists)}</span>}
			<div className="flex items-center gap-1 rounded-[18px] bg-[#E9E9EB] px-3.5 py-3">
				<span className="sr-only">{caption(typists)}</span>
				{[0, 1, 2].map(i => (
					<span
						key={i}
						aria-hidden="true"
						className="h-1.5 w-1.5 animate-bounce rounded-full bg-gray-500"
						style={{ animationDelay: `${i * 150}ms`, animationDuration: '1s' }}
					/>
				))}
			</div>
		</div>
	)
}

export default TypingIndicator
